import { initializeApp, } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getMessaging, getToken, MessagePayload, Messaging, onMessage } from "firebase/messaging";
import { notificationService } from "./PushNotificationService";
import { utils } from "../utils";
import { DetectEnvironment } from "../EnvironmentSettings";


class FireBaseService {

    private messaging: Messaging = null!;
    private token: string = null!;

    constructor() {
        if (!utils.isElectronBuild() && !utils.isDevEnvironment()) {
            this.Setup()
                .then(() => {
                    onMessage(this.messaging, (message: MessagePayload) => {
                        // if(message.notification != null) {
                        //     notificationService.showNotification(message.notification?.title ?? "", message.notification.body ?? "",3000);
                        // }
                    });
                });
        }

    }

    async Setup() {
        try {


            const app = initializeApp(DetectEnvironment.config.REACT_APP_FIREBASE_CONFIG);

            if (!utils.isElectronBuild() && process.env.NODE_ENV != "development") {
                const appCheck = initializeAppCheck(app, {
                    provider: new ReCaptchaV3Provider(DetectEnvironment.config.REACT_FIREBASE_SITE_KEY),
                    isTokenAutoRefreshEnabled: true
                });
            }

            this.messaging = getMessaging();
            var token = await getToken(this.messaging, { vapidKey: DetectEnvironment.config.VAPID_KEY });

            this.token = token;

            //   console.log('FCM token:', token);
        } catch (ex) {
            // console.error('Firebase setup error:', ex);

        }
    }

    public get CurrentToken() {
        return this.token;
    }
}

var fireBaseService = new FireBaseService();

export { fireBaseService }
